/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [

];

export const uvieNavigation: FuseNavigationItem[] = [
    {
        id: 'admin',
        title: 'RRHH',
        type: 'group',
        icon: 'heroicons_outline:users',
        link: '/admin',
        children: [
            {
                id: 'performance-review',
                title: 'Evaluaciones de rendimiento',
                type: 'basic',
                icon: 'mat_outline:query_stats',
                link: '/admin/evaluaciones-rendimiento'
            },
            {
                id: 'perfiles',
                title: 'Perfiles',
                type: 'basic',
                icon: 'mat_outline:engineering',
                link: '/admin/perfiles'
            },
        ]
    },
    {
        id: 'uvie',
        title: 'UVIE',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/uvie/clientes'
    },
];
export const regularNavigation: FuseNavigationItem[] = [
    {
        id: 'admin',
        title: 'RRHH',
        type: 'group',
        icon: 'heroicons_outline:users',
        link: '/admin',
        children: [
            {
                id: 'performance-review',
                title: 'Evaluaciones de rendimiento',
                type: 'basic',
                icon: 'mat_outline:query_stats',
                link: '/admin/evaluaciones-rendimiento'
            },
            {
                id: 'perfiles',
                title: 'Perfiles',
                type: 'basic',
                icon: 'mat_outline:engineering',
                link: '/admin/perfiles'
            },
        ]
    },
];
export const adminNavigation: FuseNavigationItem[] = [
    {
        id: 'admin',
        title: 'RRHH',
        type: 'group',
        icon: 'heroicons_outline:users',
        link: '/admin',
        children: [
            {
                id: 'colaboradores',
                title: 'Colaboradores',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/admin/colaboradores'

            },
            {
                id: 'departamentos',
                title: 'Departamentos',
                type: 'basic',
                icon: 'mat_outline:device_hub',
                link: '/admin/departamentos'

            },
            {
                id: 'performance-review',
                title: 'Evaluaciones de rendimiento',
                type: 'basic',
                icon: 'mat_outline:query_stats',
                link: '/admin/evaluaciones-rendimiento'
            },
            {
                id: 'perfiles',
                title: 'Perfiles',
                type: 'basic',
                icon: 'mat_outline:engineering',
                link: '/admin/perfiles'
            },
        ]
    },
    {
        id: 'uvie',
        title: 'UVIE',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/uvie/clientes'
    },
];
export const adminAssistantNavigation: FuseNavigationItem[] = [
    {
        id: 'admin',
        title: 'RRHH',
        type: 'group',
        icon: 'heroicons_outline:users',
        link: '/admin',
        children: [
            {
                id: 'colaboradores',
                title: 'Colaboradores',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/admin/colaboradores'

            },
            {
                id: 'performance-review',
                title: 'Evaluaciones de rendimiento',
                type: 'basic',
                icon: 'mat_outline:query_stats',
                link: '/admin/evaluaciones-rendimiento'
            },
            {
                id: 'perfiles',
                title: 'Perfiles',
                type: 'basic',
                icon: 'mat_outline:engineering',
                link: '/admin/perfiles'
            },
        ]
    },
];
